import { IconContent } from '@icons';

export const clockwise: IconContent = {
    sm: '<path fill-rule="evenodd" d="M6.5 8V3.5h1V7H10v1H6.5Zm.5 5A6 6 0 1 0 7 1a6 6 0 0 0 0 12Zm0 1A7 7 0 1 0 7 0a7 7 0 0 0 0 14Z" />',
};
